<template>
  <div>
    <headline-container headline="Competitions" :breadcrumbs="[{text: 'Competitions'}]"/>

    <div v-if="!loading" class="container">
      <filter-form :competition="competition" :competitions="competitions" @select="navigate"/>

      <hr>

      <div v-if="competition.attributes.shared_target" class="row">
        <div class="col-sm-24">
          <shared-target-panel :competition="competition"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-16">
          <ParticipationsPanel :competition="competition" @select="competitionTeamId = $event"/>
        </div>

        <div class="col-sm-8">
          <div class="panel panel-default">
            <div class="panel-body">
              <div v-if="daysRemaining > 0">
                <div class="tw-text-center tw-text-8xl">
                  {{ daysRemaining }}
                </div>

                <div class="tw-text-center">
                  business days remaining
                </div>
              </div>

              <div v-else>
                <div class="tw-text-center tw-text-4xl tw-text-green-500">
                  The competition is over!
                </div>
              </div>

              <div class="tw-mt-4 tw-text-gray-400 tw-text-center">
                {{ competition.attributes.starts_at | date }} - {{ competition.attributes.ends_at | date }}
              </div>
            </div>
          </div>

          <div v-if="competition.attributes.prizes.length" class="panel panel-default">
            <div class="panel-heading">
              <h5>
                Prizes
              </h5>
            </div>

            <div class="panel-body">
              <table class="tw-w-full">
                <tbody>
                <tr v-for="(prize, index) in competition.attributes.prizes"
                    :class="index % 2 === 0 ? 'tw-bg-white' : 'tw-bg-slate-100'">
                  <td class="tw-p-4">
                    {{ index + 1 }}. {{ prize.text }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="competition.attributes.description" class="panel panel-default">
            <div class="panel-body">
              <div class="ck-content" v-html="competition.attributes.description"></div>

              <div class="tw-italic tw-mt-8" v-if="competition.attributes.shared_target">
                This competition features a shared target. The competition is won by all participants
                when the shared target is reached. The shared score is calculated as the sum of all
                individual scores from the ranking.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <IntervalsPanel
              v-if="competitionTeamId"
              :competition="competition"
              :competition-team-id="competitionTeamId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import moment from 'moment'
import IntervalsPanel from '@/components/Dashboards/Competitions/IntervalsPanel'
import FilterForm from '@/components/Dashboards/Competitions/FilterForm'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import ParticipationsPanel from '@/components/Dashboards/Competitions/ParticipationsPanel'
import SharedTargetPanel from '@/components/Dashboards/Competitions/SharedTargetPanel'
import Permissions from '@/mixins/Permissions'

export default {
  components: {IntervalsPanel, FilterForm, HeadlineContainer, ParticipationsPanel, SharedTargetPanel},

  mixins: [Permissions],

  data() {
    return {
      competitions: null,

      selected: null,

      competitionTeamId: null,
      loading: true,

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    competition() {
      return this.competitions.find(competition => competition.id.toString() === this.selected) || this.competitions[0]
    },

    daysRemaining() {
      let current = moment()

      let count = 0

      while (current <= moment(this.competition.attributes.ends_at)) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    }
  },

  watch: {
    '$route'() {
      this.competitionTeamId = null

      this.selected = this.$route.query.id
    }
  },

  methods: {
    load() {
      this.loading = true

      this.competitionTeamId = null

      http.get('/api/v2/competitions', {'filter[is_active]': '1', 'filter[user_id]': this.hasPermission('admin') ? null : this.shared.user.id}).then(response => {
        this.competitions = response.data.data

        this.selected = this.$route.query.id || this.competitions[0].id

        this.loading = false
      })
    },

    navigate(id) {
      this.$router.push('?id=' + id)
    }
  }
}
</script>
